<template src='./tabRemittanceReport.pug' lang='pug'></template>

<script>
import TreeGrid from '../../treeGrid/TreeGrid'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import { EXPORT_TREEGRID } from '../../../../build/jsonToExcel/exportRoutes.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../utils/grid-load-transition.js'

export default {
  name: 'TabRemittanceReport',

  components: {
    TreeGrid,
    ButtonPrimary
  },

  props: {
    idModal: {
      type: String
    },
    remittance: {
      type: Object,
      required: true
    },
    showRemovalButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      gridId: '#remittanceReportGrid',
      exportUrl: EXPORT_TREEGRID,
      treeGridCfg: {},
      result: {},
      showGrid: false
    }
  },

  methods: {
    loadTreegridReport () {
      let filter = {
        idRemessa: this.remittance.id
      }
      this.$store.dispatch('searchRemittanceSummary', filter)
        .then(response => {
          this.result = response.data
          this.treeGridCfg = response.data.Cfg.Layout
          stopTreeGridLoading(this.gridId)
        })
        .catch(error => {
          stopTreeGridLoading(this.gridId)
          this.$root.$refs.notification.error(error)
        })
    },

    openModalConfirm () {
      $('#confirmRemittanceRemoval').modal('show')
    },

    closeModalConfirm () {
      $('#confirmRemittanceRemoval').modal('hide')
    }
  },

  mounted () {
    this.showGrid = true
    startTreeGridLoading(this.gridId)
    this.loadTreegridReport()
  }
}
</script>

<style scoped>
.margin-container {
  margin-top: 15px;
}

.remittance-report {
  height: 62vh;
  overflow-y: auto;
}

.tab-footer {
  height: 9vh;
  border-top: 2px solid #d0d0d0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// TabRemittanceReport.vue?76399b6a